export { DifficultyLevel as ProgramDifficultyLevel } from "./program";

// Workout Location
export enum WorkoutLocation {
  GYM = "gym",
  HOME = "home",
  BOTH = "both",
}

// Fitness Goal (multi-select)
export enum FitnessGoal {
  GET_STRONG = "get_strong",
  GET_FIT = "get_fit",
  GROW_MUSCLE = "grow_muscle",
  IMPROVE_MOBILITY = "improve_mobility",
}

// Focus Area (multi-select)
export enum FocusArea {
  GLUTES = "glutes",
  QUADS = "quads",
  HAMSTRINGS = "hamstrings",
  CALVES = "calves",
  BACK = "back",
  SHOULDERS = "shoulders",
  CHEST = "chest",
  TRICEPS = "triceps",
  BICEPS = "biceps",
  CORE = "core",
}

// Body Composition
export enum BodyComposition {
  LOSE_FAT = "lose_fat",
  BUILD_MUSCLE = "build_muscle",
  MAINTAIN_WEIGHT = "maintain_weight",
}

// Display name mappings
export const ProgramDifficultyLevelLabels: Record<string, string> = {
  beginner: "Beginner",
  intermediate: "Intermediate",
  advanced: "Advanced",
};

export const WorkoutLocationLabels: Record<WorkoutLocation, string> = {
  [WorkoutLocation.GYM]: "Gym",
  [WorkoutLocation.HOME]: "Home",
  [WorkoutLocation.BOTH]: "Both",
};

export const FitnessGoalLabels: Record<FitnessGoal, string> = {
  [FitnessGoal.GET_STRONG]: "Get Strong",
  [FitnessGoal.GET_FIT]: "Get Fit",
  [FitnessGoal.GROW_MUSCLE]: "Grow Muscle",
  [FitnessGoal.IMPROVE_MOBILITY]: "Improve Mobility",
};

export const FocusAreaLabels: Record<FocusArea, string> = {
  [FocusArea.GLUTES]: "Glutes",
  [FocusArea.QUADS]: "Quads",
  [FocusArea.HAMSTRINGS]: "Hamstrings",
  [FocusArea.CALVES]: "Calves",
  [FocusArea.BACK]: "Back",
  [FocusArea.SHOULDERS]: "Shoulders",
  [FocusArea.CHEST]: "Chest",
  [FocusArea.TRICEPS]: "Triceps",
  [FocusArea.BICEPS]: "Biceps",
  [FocusArea.CORE]: "Core",
};

export const BodyCompositionLabels: Record<BodyComposition, string> = {
  [BodyComposition.LOSE_FAT]: "Lose Fat",
  [BodyComposition.BUILD_MUSCLE]: "Build Muscle",
  [BodyComposition.MAINTAIN_WEIGHT]: "Maintain Weight",
};

// Validation constraints
export const STEP_TARGET_CONSTRAINTS = {
  MIN: 1000,
  MAX: 50000,
};

export const TRAINING_FREQUENCY_CONSTRAINTS = {
  MIN: 1,
  MAX: 7,
};

// Update fitness data input interface
export interface UpdateFitnessDataInput {
  fitness_level?: string;
  workout_location?: WorkoutLocation;
  fitness_goal?: FitnessGoal[];
  training_frequency?: string;
  focus_area?: FocusArea[];
  body_composition?: BodyComposition;
  step_target?: number;
}
